import '@ungap/global-this'
import './assign';
import './find';
import './startsWith';
import './closest';
